export default "__VITE_ASSET__C8bZvz_n__"